import React from 'react'
import { Table } from 'antd';
import moment from 'moment';
import "moment/locale/en-nz";

class ContributionTable extends React.Component {
  constructor(props) {
    super(props)
    this.firstColumn = props.firstColumn? props.firstColumn : "name"
    this.columns = [
      {
        title: this.firstColumn==="name"?  'Member':'Date',
        dataIndex: 'member',
        key: 'contributorId'
      },
      {
        title: 'Amount',
        dataIndex: 'total',
        width: 120,
        align: 'right'
      }
    ]
  }
  rowClassName = (rec, index) => {

    if(this.props.selectedRow  < 0) {
      return ''
    }

   // let classname = index === this.props.selectedRow ? 'selectedRow' : ''
   let classname = this.props.contributions[ this.props.selectedRow].contributionId === +  rec.contributionId ? 'selectedRow' : ''
    return classname
  }
  renderFooterTable = (total) => {
    const dataList = [{
      member: "Total",
      total,
      key: "total"
    }];
    return (
      <Table
        className="footer"
        pagination={false}
        size="middle"
        showHeader={false}
        columns={this.columns}
        rowClassName={"footer"}
        dataSource={dataList}
      />
    );
  }

  DisplayByMember = x => {
    x.key = x.contributionId
    let member = '(' + x.offeringNo.toString() + ') ' + x.displayName
    let total = x.total.toFixed(2)
    //total += x.total
    return Object.assign({}, x, { member , total })
  }

  DisplayByDate = x => {
    x.key = x.contributionId
    let contDate = moment(x.contributionDate).format("DD MMM YYYY")
    let member = contDate  //x.contributionDate
    let total = x.total.toFixed(2)
    return Object.assign({}, x, { member, total })
  }

  render() {
    let displayBy = this.DisplayByMember 
    if (this.firstColumn === "date") {
      displayBy= this.DisplayByDate
    }

    let source = this.props.contributions.map(
      displayBy
    )
     
    let total = this.props.contributions.reduce( 
      (accumulator, item ) => accumulator + item.total, 0
    )

    
    let pagingation = false
    if (this.firstColumn !== "name") {
      pagingation = { position: 'top' }
    }
    return ( 
    <div><Table columns={this.columns} dataSource={source}
    size="middle" rowClassName={this.rowClassName}
        pagination={pagingation}
        onRow={
        (record, rowIndex) => {
          return {
            onClick: () => this.props.rowClick(record.contributionId)
          }
        }
      }
    /> {this.renderFooterTable(total.toFixed(2))}</div>
    )
  }
}

export default ContributionTable
